<!---------------------- FOOTER BEGINN ------------------------>
<div class="hr_bottom">
  @if (eStatus) {
    <div class="adminNotices">
      @if (eStatus.debug_option) {
        <div class="debug">
          <span>DEBUG:</span>
          <br />
          <span>Stream-Source: {{ eStream }}</span>
          <br />
          <span>Intranet-Status: {{ debugAssignServer }}</span>
        </div>
      }
      @if (eStatus.phase === 'live') {
        <div class="server">{{ serverDisplay }}</div>
      }
    </div>
  }
  @if (optionalText || optionalLink) {
    <div class="hr_optional">
      @if (optionalText) {
        <span>{{ optionalText }}</span>
      }
      @if (optionalLink) {
        <a target="_blank" rel="noopener noreferrer" [href]="optionalLink">{{ optionalLinkText }}</a>
      }
    </div>
  }
  <div class="hr_footer">
    <div class="hr_links">
      <div class="hr_policy">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="{{ environmentVars.apiUrl }}{{ environmentVars.eventPrefix }}misc/impressum.php?ln={{ activeLang() }}"
          >{{ eLangGlob()?.translateImprint }}</a
        >
      </div>
      <div class="hr_legal_notice">
        @if (environmentVars.customer !== 'rwe') {
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="{{ environmentVars.apiUrl }}{{ environmentVars.eventPrefix }}misc/datenschutz.php?ln={{ activeLang() }}"
            >{{ eLangGlob()?.translateDatapolicy }}</a
          >
        } @else {
          <a
            target="_blank"
            rel="noopener noreferrer"
            [href]="activeLang() === 'de' ? 'https://www.rwe.com/datenschutz/konferenz/' : 'https://www.rwe.com/en/data-protection/conference/'"
            >{{ eLangGlob()?.translateDatapolicy }}</a
          >
        }
      </div>
      <div class="hr_tech_info">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="{{ environmentVars.apiUrl }}{{ environmentVars.eventPrefix }}misc/technik.php?ln={{ activeLang() }}"
          >{{ eLangGlob()?.translateTechInfo }}</a
        >
      </div>
    </div>
    <div class="hr_contact">
      <span class="hr_stoerung">{{ eLangGlob()?.translateSendmail }}: </span>
      <a
        class="hr_stoerung_link"
        href="mailto:{{ environmentVars.email }}?subject={{ eLangGlob()?.translateEmailSubject + mailSubjectServer }}"
        >{{ environmentVars.email }}</a
      >
    </div>
  </div>
</div>
<!-------------------------- FOOTER ENDE -------------------------->
